import { AccessManager } from '../../components/ui/access-manager/access-manager';
import { Person } from '../person/person';
import { NavService } from '../ui/navService';
import { StorageService } from '../../core/storage/storageService';
import { UserRole } from '../../../../../../libs/Shared/components/model/UserRoles';

export class User extends Person {
  public id: string;
  public accessBits: string;
  public accessLevel: number;
  public originalRole: UserRole;
  public organizationIds: string[] | undefined;
  public isDisabled: boolean;
  public requiresPasswordReset: boolean | undefined;
  public canBeImpersonated: boolean = false;
  public contactTypes: string[] = [];

  constructor(u: Partial<User>) {
    super(u);

    if (u.id == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n id cannot be null`,
      );
    if (u.emailAddress == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n emailAddress cannot be null`,
      );
    if (u.accessBits == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n accessBits cannot be null`,
      );
    if (u.isDisabled == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n isDisabled cannot be null`,
      );
    if (u.accessLevel == null)
      throw new Error(
        `Invalid user in constructor: ${JSON.stringify(u)}\n accessLevel cannot be null`,
      );

    if (u.canBeImpersonated) {
      this.canBeImpersonated = u.canBeImpersonated;
    }

    this.id = u.id;
    this.organizationIds = u.organizationIds;
    this.emailAddress = u.emailAddress;
    this.accessBits = u.accessBits;
    this.accessLevel = u.accessLevel;
    this.originalRole = u.originalRole || '';
    this.isDisabled = u.isDisabled;
    this.requiresPasswordReset = u.requiresPasswordReset;
    this.contactTypes = u.contactTypes ? [...u.contactTypes] : [];
  }

  static override createEmpty(): Partial<User> {
    const user = super.createEmpty() as Partial<User>;
    user.id = '';
    user.organizationIds = [];
    user.accessBits = '';
    user.originalRole = '';
    user.isDisabled = false;
    user.accessLevel = -1;
    user.requiresPasswordReset = false;
    user.contactTypes = [];
    return user;
  }

  public static override clone(userToCopy: Partial<User>): Partial<User> {
    let sThisUser = JSON.stringify(userToCopy);
    return JSON.parse(sThisUser);
  }

  public isSwipesumInternalUser(): boolean {
    return NavService.checkUserAccess(
      StorageService.getAllAccessNamespaces(),
      AccessManager.AUTH_MANAGE_ALL_USERS,
      this.accessBits,
    );
  }
}
